import { render, staticRenderFns } from "./reverse-receipt.vue?vue&type=template&id=c8d049ec&"
import script from "./js/reverse-receipt.js?vue&type=script&lang=js&"
export * from "./js/reverse-receipt.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports